import { isAxiosError } from "axios";
import { paymentsApi } from "../httpService";


const categoryService = {
    getCategories: async (query: Object = {}): Promise<any> => {
        try {
            return (await paymentsApi.get<any>("/apps/categories", {
                params: query,
            })).data;
        } catch (error: any) {
            if (isAxiosError(error)) {
                const status = error.response?.status;
                if (status && status >= 400 && status < 500) {
                    return new Promise((_, reject) => reject(error.response?.data?.errors[0].message));
                }
            }

            //throw new Error('An unexpected error occurred.');
            return new Promise((_, reject) => reject('An unexpected error occurred.'));
        }
    },


    createCategory: async (data: Object): Promise<any> => {
        try {
            return (await paymentsApi.post("/apps/categories", data)).data;
        } catch (error: any) {
            if (isAxiosError(error)) {
                const status = error.response?.status;
                if (status && status >= 400 && status < 500) {
                    return new Promise((_, reject) => reject(error.response?.data?.errors[0].message));
                }
            }

            //throw new Error('An unexpected error occurred.');
            return new Promise((_, reject) => reject('An unexpected error occurred.'));
        }
    },


    updateCategory: async (id: number | string, data: Object): Promise<any> => {
        try {
            return (await paymentsApi.post(`/apps/categories/${id}`, data)).data;
        } catch (error: any) {
            if (isAxiosError(error)) {
                const status = error.response?.status;
                if (status && status >= 400 && status < 500) {
                    return new Promise((_, reject) => reject(error.response?.data?.errors[0].message));
                }
            }

            //throw new Error('An unexpected error occurred.');
            return new Promise((_, reject) => reject('An unexpected error occurred.'));
        }
    },

}

export default categoryService;